var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHubBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_3521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_512_3521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 30,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1055 0.724609H1.10547V31.7246H30.1055V0.724609Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_512_3521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5624 13.7776C25.5286 14.4642 25.0076 15.312 24.1681 16.1268V26.8641C24.1671 27.1406 24.0582 27.375 23.8742 27.5581C23.6893 27.7376 23.4494 27.8437 23.1674 27.8456H5.66895C5.38881 27.8437 5.14799 27.7375 4.96307 27.5581C4.77903 27.375 4.67104 27.1406 4.6701 26.8641V9.70529C4.67104 9.42973 4.77903 9.19441 4.96307 9.0113C5.14799 8.83183 5.38881 8.72566 5.66895 8.72384H14.9625C15.7141 7.73689 16.5903 6.72614 17.5827 5.79966C17.5873 5.79415 17.591 5.78864 17.5956 5.7832H5.66895C4.57032 5.78226 3.56051 6.22447 2.8418 6.93129C2.11946 7.63811 1.66899 8.62688 1.66992 9.70535V26.8642C1.66899 27.9426 2.11946 28.9333 2.8418 29.6382C3.56045 30.3449 4.57032 30.7862 5.66895 30.7862H23.1675C24.2679 30.7862 25.2778 30.3449 25.9964 29.6381C26.717 28.9332 27.1683 27.9425 27.1674 26.8641V12.7082C27.1674 12.7082 27.1601 12.6991 27.1482 12.6899C26.6931 13.0799 26.163 13.4516 25.5624 13.7776Z",
    fill: "url(#paint0_linear_512_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.073 0.787109C30.073 0.787109 29.1538 2.16042 23.1498 4.19192C17.0276 6.2638 13.2593 14.6922 13.2593 14.6922C12.352 16.4189 8.76584 23.5929 8.76584 23.5929C7.77801 25.4459 9.58797 26.5409 10.65 24.6274C12.6852 20.9543 13.999 17.598 17.0935 17.5028C21.608 17.3636 24.6951 13.4214 23.7237 13.6045C22.4456 14.1611 19.6277 13.6466 21.2875 13.3903C25.2719 13.0708 27.7273 10.076 26.9272 9.87282C25.5145 10.4166 24.1971 9.9003 23.9389 9.74463C30.9711 8.88951 30.073 0.787109 30.073 0.787109Z",
    fill: "url(#paint1_linear_512_3521)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_3521",
    x1: 4.88344,
    y1: -9.6277,
    x2: 34.3148,
    y2: -3.4906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_512_3521",
    x1: 11.2065,
    y1: -14.525,
    x2: 36.4586,
    y2: -10.0293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_3521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.549805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubBlog);
export default __webpack_public_path__ + "static/media/hub_blog.e3c58586208e7b45d94480e5d59005a0.svg";
export { ForwardRef as ReactComponent };